import clsx from 'clsx'
import { useLatestCallback } from 'hook/useLatestCallback'
import { ChangeEvent } from 'react'
import css from './Switch.module.scss'

interface SwitchProps {
  checked: boolean
  disabled?: boolean
  onChange: (checked: boolean) => void
}

export function Switch(props: SwitchProps) {
  const { checked, disabled } = props

  const onChange = useLatestCallback((event: ChangeEvent<HTMLInputElement>) => {
    if (disabled) return
    const checked = event.target.checked
    props.onChange(checked)
  })

  return <label className={clsx(css.switch, checked && css.checked, disabled && css.disabled)}>
    <input className={css.input} type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
    <span className={css.slider}></span>
  </label>
}
